import { getdirectusUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchMeetingDataForForm({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        getdirectusUserFields("user_created"),
        "starts_at",
        "ends_at",
        "participants.id",
        "participants.participant.id",
        "participants.participant.email",
      ],
    };
    const response = await getItemFromCollection("calendar_events", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
